
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTide as ObiTideElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-tide.js';
 
 
 

 
 export const ObiTide = createComponent({
   react: React,
   tagName: 'obi-tide',
   elementClass: ObiTideElement,
   events: {
     
   }
  });
 
 